<script>
import BoardCard from "@/components/BoardCard.vue";
import {Bubble} from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  PointElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement
} from 'chart.js'

ChartJS.register(Title, PointElement, Tooltip, Legend, LineElement, CategoryScale, LinearScale)

export default {
  name: 'CountByLevelAndDate',
  components: {Bubble, BoardCard},
  props: {
    title: {
      type: String,
      default: "Ошибки по времени"
    }
  },
  data() {
    return {
      bubbleData: null,
      bubbleOptions: {
        plugins: {
          legend: {
            display: false // Полностью скрыть легенду
          }
        },
        responsive: true,
        fill: false,
        layout: {
          padding: 0
        },
        scales: {
          x: {
            type: 'category', // Используем категориальную шкалу
            ticks: {
              autoSkip: false
            }
          },
          y: {
            min: 0,
            max: 24,
            ticks: {
              backdropPadding: 10,
              padding: 1
            }
          },
        }
      }
    }
  },
  computed: {
    // Computed свойство для обновления options
    chartOptions() {
      return {
        ...this.bubbleOptions,
        scales: {
          ...this.bubbleOptions.scales,
          x: {
            ...this.bubbleOptions.scales.x,
            labels: this.bubbleData?.labels || [] // Безопасное обращение
          }
        }
      }
    }
  },
  methods: {
    loadData: function () {
      console.log("load token")
      let c = this;
      c.bubbleData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/log/dashboard/count-by-level-and-date').then(function(response) {
        console.log(response.data);
        c.bubbleData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <BoardCard :title="title" v-if="bubbleData != null">
    <Bubble
        id="my-chart-id3"
        :options="chartOptions"
        :data="bubbleData"
    />
  </BoardCard>
</template>

<style scoped>

</style>